//  Copyright (c) 2022 Generated Systems Technologies, Inc. All rights reserved.

import React, { useEffect } from 'react';
import '../App.css';
import '../css/branding.css';
import AWS from 'aws-sdk';
import PageHeader from '../components/PageHeader';
import { API, Auth } from 'aws-amplify';
import config from '../config';
import queryString from 'query-string';

//-----------------------------------------------------------------------------
// Home acts a default landing page after integrating with Sage or QuickBooks
// files. Routing to the correct page is done after parsing the query string.
//-----------------------------------------------------------------------------
// Query String Parameters:
//    From Sage:
//      code
//      country
//      state: "sage"
//    From QuickBooks
//      code
//      realmId
//      state
//    From ?
//      identity
//-----------------------------------------------------------------------------

function Home(props) {
  useEffect(() => {
    onLoad();
  }, []);

  
  function parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
};

  async function onLoad() {
    console.log('Home onLoad()');

    try {
      var query_string_params = queryString.parse(window.location.search);

      const parsedHash = new URLSearchParams(
        window.location.hash.substring(1) // skip the first char (#)
      );

//      var access_token = parsedHash.get("access_token");
//        var id_token = parsedHash.get("id_token"); 
//        var jwtToken = parseJwt(id_token);

//      var region = config.cognito.REGION;
//      var idPool = config.cognito.IDENTITY_POOL_ID;
//      var appclientid = config.cognito.APP_CLIENT_ID;

//      var loginstr = '\"cognito-idp.' + config.cognito.REGION + '.amazonaws.com/' + config.cognito.USER_POOL_ID + '\"';
      // SSO - AUTH0
      if (parsedHash.has("id_token"))
      {
        var id_token = parsedHash.get("id_token"); 
        var jwtToken = parseJwt(id_token);
        sessionStorage['awsToken'] = parsedHash.get("id_token");
//        sessionStorage['awsIdentity'] = parseJwt(id_token).identities[0].userId;
        sessionStorage['awsIdentity'] = parseJwt(id_token)["cognito:username"];

        AWS.config.region = config.cognito.REGION;        
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: config.cognito.IDENTITY_POOL_ID,
//          IdentityId: sessionStorage['awsIdentity'],
          Logins: {
            [config.cognito.SSO_IDENTITY_PROVIDER_NAME]: sessionStorage['awsToken'],
          },
        });

        AWS.config.credentials.refresh(async function (err) {
          if (err) {
            console.log(err);
            props.history.push({ pathname: '/loggedout', state: { error: err.message } });
          } else {
            sessionStorage['last_activity_time'] = new Date().getTime();

            var data = await getQBFileList();
            console.log(data);

            if (data.files !== undefined)
            {
              if (data.files.length > 0) {
                console.log('/upcomingdeliveries');
                props.history.push('/upcomingdeliveries');
              } else {
                console.log('/connectaccountingsystem');
                props.history.push('/connectaccountingsystem');
              }
            }
            else // SSO?
            {
              if (data.eula_accepted === false)
              {
                props.history.push({pathname: "/eula", state: {"user_id": sessionStorage['awsIdentity']} });
              }
            }
          }
        });
      }
      //  SSO - DEVELOPER IDENTITY
      else if ('identity' in query_string_params)
      {
        sessionStorage['awsIdentity'] = query_string_params.identity;
        sessionStorage['awsToken'] = query_string_params.token;

        AWS.config.region = config.cognito.REGION;
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: config.cognito.IDENTITY_POOL_ID,
          IdentityId: query_string_params.identity,
          Logins: {
            'cognito-identity.amazonaws.com': query_string_params.token,
          },
        });
        AWS.config.credentials.refresh(async function (err) {
          if (err) {
            console.log(err);
            props.history.push({ pathname: '/loggedout', state: { error: err.message } });
          } else {
            sessionStorage['last_activity_time'] = new Date().getTime();

            var data = await getQBFileList();
            console.log(data);

            if (data.files !== undefined)
            {
              if (data.files.length > 0) {
                console.log('/upcomingdeliveries');
                props.history.push('/upcomingdeliveries');
              } else {
                console.log('/connectaccountingsystem');
                props.history.push('/connectaccountingsystem');
              }
            }
            else // SSO?
            {
              if (data.eula_accepted === false)
              {
                props.history.push({pathname: "/eula", state: {"user_id": sessionStorage['awsIdentity']} });
              }
            }
          }
        });
      }
      else if ('state' in query_string_params && query_string_params.state === 'sage')
      {
        process_sage_response(query_string_params);
      }
      else if ('realmId' in query_string_params || 'error' in query_string_params)
      {
        process_quickbooks_response(query_string_params);
      }
    } catch (e) {
      if (e !== 'No current user') {
        alert(e);
      }
    }
  }

  async function process_sage_response(query_string_params)
  {
    console.log('Home process_sage_response()');
    if (config.bank.SSO === 'true') {

      AWS.config.region = config.cognito.REGION;
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: config.cognito.IDENTITY_POOL_ID,
//        IdentityId: sessionStorage['awsIdentity'],
        Logins: {
          [config.cognito.SSO_IDENTITY_PROVIDER_NAME]: sessionStorage['awsToken'],
//          'cognito-identity.amazonaws.com': sessionStorage['awsToken'],
        },
      });

      AWS.config.credentials.refresh(async function (err) {
        console.log('AWS.config.credentials.refresh');
        if (err) {
          console.log(err);
          props.history.push({ pathname: '/loggedout', state: { error: err.message } });
        } else {
          sessionStorage['last_activity_time'] = new Date().getTime();

          props.history.push({
            pathname: '/sagecompanyfilelist',
            sage_props: query_string_params,
          });
        }
      });
    } else {
      sessionStorage['last_activity_time'] = new Date().getTime();

      await Auth.currentSession();
      props.setIsAuthenticated(true);

      props.history.push({ pathname: '/sagecompanyfilelist', sage_props: query_string_params });
//      props.history.push({ pathname: '/sagecompanyfilelist', state: { sageprops: query_string_params } });
    }
  }

  async function process_quickbooks_response(query_string_params)
  {
    console.log('Home process_quickbooks_response()');
    if (config.bank.SSO === 'true')
    {
      AWS.config.region = config.cognito.REGION;
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: config.cognito.IDENTITY_POOL_ID,
//        IdentityId: sessionStorage['awsIdentity'],
        Logins: {
          [config.cognito.SSO_IDENTITY_PROVIDER_NAME]: sessionStorage['awsToken'],
//          'cognito-identity.amazonaws.com': sessionStorage['awsToken'],
        },
      });

      AWS.config.credentials.refresh(async function (err) {
        console.log('AWS.config.credentials.refresh');
        if (err) {
          console.log(err);
          props.history.push({ pathname: '/loggedout', state: { error: err.message } });
        } else {
          sessionStorage['last_activity_time'] = new Date().getTime();

          props.history.push({
            pathname: '/connecttoquickbooksresult',
            quickbooks_props: query_string_params,
          });
        }
      });
    } 
    else
    {
      sessionStorage['last_activity_time'] = new Date().getTime();

      await Auth.currentSession();
      props.setIsAuthenticated(true);

      props.history.push({
        pathname: '/connecttoquickbooksresult',
        quickbooks_props: query_string_params,
      });
    }
  }

  function getQBFileList() {
    console.log('getQBFileList()');
    return API.get('cloudautocheckissues', '/getQBFileList', {
      queryStringParameters: {
        app_prefix: config.environment.APP_PREFIX,
      },
    });
  }

  return (
    <div>
      <PageHeader title='' info='' />
    </div>
  );
}

export default Home;
